import { AnalyticsService } from './services/analytics.service';
import { AnalyticsEffects } from './store/effects/index';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature(AnalyticsEffects)],
  providers: [AnalyticsService],
})
export class AnalyticsModule {}
